import React from 'react';
import HiddenAlbumManagement from './HiddenAlbumManagement';
import HomeReviewManagement from './HomeReviewManagement';
import DirectCatalogManagement from './DirectCatalogManagement';
import DirectCatalogAppleManagement from './DirectCatalogAppleManagement';

const AlbumManagement = ({ subTab, searchParams, updateURL, onCountsChange }) => {
  switch (subTab) {
    case 'hidden-album':
      return (
        <HiddenAlbumManagement
          searchParams={searchParams}
          updateURL={updateURL}
          onCountsChange={onCountsChange}
        />
      );
    case 'direct-catalog':
      return <DirectCatalogManagement />;
    case 'direct-apple':
      return <DirectCatalogAppleManagement />;
    case 'home-screen':
    default:
      return <HomeReviewManagement onCountsChange={onCountsChange} />;
  }
};

export default AlbumManagement;
